module.exports = __webpack_public_path__ + "static/media/buffalo_map_thumb_home_2.93ff7258.jpg";